common.factory('sectionsResource', ['$resource', function ($resource) {
  return $resource('/sections');
}]);